import { Button } from '@strata/react-buttons';
import { WarningDialog } from '@strata/react-dialog';
import { SuccessToast } from '@strata/react-toast-message';
import { useState } from 'react';

import { usePostCancelEpaCaseMutation } from 'store/api/epaApi';

interface CancelPARequestDialogProps {
    isOpen: boolean;
    onClose: () => void;
    epaCaseId: string;
    intakeCaseId: string;
}

export const CancelPARequestDialog = ({
    isOpen,
    onClose,
    epaCaseId,
    intakeCaseId,
}: CancelPARequestDialogProps) => {
    const [postCancelEpaCase] = usePostCancelEpaCaseMutation();
    const [isSubmitting, setIsSubmitting] = useState(false);
    return (
        <WarningDialog
            dialogTitle="Confirm Cancel PA Request"
            isOpen={isOpen}
            primaryButtonLabel="Yes, Cancel Prior Auth"
            primaryButtonIntent={Button.Intent.DANGER}
            primaryButtonDisabled={isSubmitting}
            onPrimaryButtonClick={() => {
                void (async () => {
                    try {
                        setIsSubmitting(true);
                        await postCancelEpaCase({ epaCaseId, intakeCaseId }).unwrap();
                        SuccessToast({ message: 'Prior auth canceled successfully.' });
                        onClose();
                    } finally {
                        setIsSubmitting(false);
                    }
                })();
            }}
            secondaryButtonLabel="Cancel"
            onSecondaryButtonClick={onClose}
            dialogContent={
                <div className="margin__bottom--medium">
                    Are you sure you want to cancel this prior auth request. This action cannot be
                    undone.
                </div>
            }
        />
    );
};
